<script>
import { Remarkable } from 'remarkable'

import mixin from '@/mixins/mixin.vue'
import constants from './constants'

const THUMBS_UP_OUTLINED_SVG = `
  <svg width="20" height="18" viewBox="0 0 24 24" fill="none">
    <path stroke="#a0aec0" stroke-width="2" fill="none" d="M2,20V10H6V20H2M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10Z"/>
  </svg>
`

const THUMBS_DOWN_OUTLINED_SVG = `
  <svg width="20" height="18" viewBox="0 0 24 24" fill="none">
    <path stroke="#a0aec0" stroke-width="2" fill="none" d="M15 3H6C5.17 3 4.46 3.5 4.16 4.22L1.14 11.27C1.05 11.5 1 11.74 1 12V14A2 2 0 0 0 3 16H9.31L8.36 20.57C8.34 20.67 8.33 20.77 8.33 20.88C8.33 21.3 8.5 21.67 8.77 21.94L9.83 23L16.41 16.41C16.78 16.05 17 15.55 17 15V5C17 3.89 16.1 3 15 3M19 15H23V3H19V15Z"/>
  </svg>
`

export default {
  mixins: [mixin],

  mounted() {
    window.handleAIMessageFeedback = this.handleAIMessageFeedback
  },

  beforeDestroy() {
    delete window.handleAIMessageFeedback
  },

  data() {
    return {
      markdownParser: new Remarkable(),
      feedbackButtonsStyles: `
        .ai-message-container {
          background-color: #ffff;
          padding: 10px;
          color: #4a5568;
          font-family: Inter, sans-serif;
          border-radius: 8px;
          position: relative;
        }

        .ai-message-content {
          line-height: 1.5;
        }

        .ai-message-content p {
          margin: 0 !important;
          margin-bottom: 8px !important;
        }

        .ai-message-container .feedback-icon {
          background: transparent;
          border: none;
          padding: 0;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .ai-message-container .feedback-icon:focus {
          outline: none;
        }

        .ai-message-container .feedback-chip {
          opacity: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          background: white;
          right: -12px;
          border-radius: 8px;
          height: 24px;
        }

        .ai-message-container:hover .feedback-chip {
          opacity: 1;
        }

        .ai-message-container .feedback-chip button {
          border: 1px solid #cbd5e0;
          border-radius: 8px;
          padding: 4px 6px;
        }

        .ai-message-container .feedback-chip button:first-child {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        .ai-message-container .feedback-chip button:last-child {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: none;
        }

        .ai-message-container .feedback-chip button:hover {
          background-color: #f2f5fa;
        }
      `,
    }
  },

  methods: {
    getHTMLMessageWithoutFeedbackButtons(content) {
      const markdownContent = this.markdownParser.render(content)

      return `
        <div class="ai-message-container">
          <div class="ai-message-content">${markdownContent}</div>
        </div>
      `
    },

    getHTMLMessageWithFeedbackButtons(content, metadata = {}) {
      const { messageId, threadId, userMessage } = metadata
      const shouldRenderFeedbackButtons = !this.wasFeedbackAlreadyGiven(
        messageId
      )

      if (!shouldRenderFeedbackButtons) {
        return this.getHTMLMessageWithoutFeedbackButtons(content)
      }

      const markdownContent = this.markdownParser.render(content)
      const contentWithEscapedCharacters = content
        .replaceAll('\n', ' ')
        .replaceAll("'", '')
        .replaceAll('"', '')

      return `
        <div class="ai-message-container">
          <div class="ai-message-content">${markdownContent}</div>

          <span class="feedback-chip">
            <button
              class="feedback-icon"
              onclick="window.handleAIMessageFeedback('like', '${messageId}', '${threadId}', '${userMessage}', '${contentWithEscapedCharacters}')"
              type="button"
            >
              ${THUMBS_UP_OUTLINED_SVG}
            </button>
            <button
              class="feedback-icon"
              onclick="window.handleAIMessageFeedback('dislike', '${messageId}', '${threadId}', '${userMessage}', '${contentWithEscapedCharacters}')"
              type="button"
            >
              ${THUMBS_DOWN_OUTLINED_SVG}
            </button>
          </span>
        </div>
      `
    },

    // We're intentionally passing individual parameters instead of a stringified object to prevent expensive operations as well as issues with quote characters
    handleAIMessageFeedback(
      feedbackType,
      messageId,
      threadId,
      userMessage,
      responseMessage
    ) {
      if (this.wasFeedbackAlreadyGiven(messageId)) {
        this.showInfo(this.$t('ai_features.message_feedback_already_given'))
        return
      }

      this.$emit(
        feedbackType === 'like'
          ? 'positiveFeedbackReceived'
          : 'negativeFeedbackReceived',
        {
          messageId,
          threadId,
          userMessage,
          responseMessage,
        }
      )
    },

    wasFeedbackAlreadyGiven(messageId) {
      return Boolean(
        window.localStorage.getItem(
          `${constants.FEEDBACK_CACHE_KEY_PREFIX}${messageId}`
        )
      )
    },
  },
}
</script>
